import { useContext } from 'react';

import { ModalContext } from 'contexts/contexts';

const useModalContext = () => {
  const modalContext = useContext(ModalContext);
  return modalContext;
};

export default useModalContext;
